import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

// Async thunk to fetch banners
export const fetchBanners = createAsyncThunk(
  "banner/fetchBanners",
  async () => {
    const response = await axios.get(apiurl + "banner");
    return response.data.data; // Assuming the banner data is in `data`
  }
);

// Initial state
const initialState = {
  banners: [],
  loading: false,
  status: "idle",
  error: null,
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.banners = action.payload;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default bannerSlice.reducer;
